<template>
  <div>
    <b-card>
      <b-card-body>
          <b-row>
              <b-col sm="6" v-if="listarEmpresas">
                  <label for="empresa">Seleccione Empresa</label>
                  <br>
                  <el-select v-model="selectedEmpresa.id" filterable remote :remote-method="buscarEmpresa" no-data-text="No hay datos que coincidan" no-match-text="No hay datos que coincidan" @change="obtenerProductosPagos">
                    <el-option v-for="item in listaEmpresas" :key="item.id" :label="item.nombre" :value="item.id"></el-option>
                  </el-select>
              </b-col>
              <b-col v-else><span></span></b-col>
              <b-col sm="6">
                  <b-button class="mt-4 float-right" :disabled="!selectedEmpresa.id" variant="primary" :to="`/matriz-compatibilidad/${tipoMatriz.tipo}/crear`" v-text="'Ingresar productos'" />
              </b-col>     
          </b-row>
          <b-tabs class="mt-5" v-if="((listarEmpresas && selectedEmpresa.id) || !listarEmpresas) && tipoMatriz.tipo != 'transporte'">
            <b-tab title="Resultados">
              <b-table responsive striped hover :fields="columnas" :items="listadoResultados"></b-table>
              <el-pagination
                  @size-change="setPerPagePagination"
                  @current-change="setPagePagination"
                  class="float-right"
                  v-model="filtroResultados.page"
                  :current-page="filtroResultados.page"
                  :page-sizes="[10, 30, 50, 100]"
                  :page-size="filtroResultados.perPage"
                  layout="total,sizes,prev,pager,next"
                  :total="total.resultados"
              >
              </el-pagination>
              <br />
            </b-tab>
            <b-tab title="Productos comparados">
              <GenerarMatriz></GenerarMatriz>
            </b-tab>
          </b-tabs>
        </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import { getAcls, validarPermisoComponente } from "../../plugins/acl";
import loader from "../../containers/loader";
import GenerarMatriz from './generarMatriz/Main';

export default {
    name: "matriz-formulario",
    data() {
      return {
        acls: '',
        rol: '',
        listarEmpresas: false,
        listaEmpresas: [],
        loading: false,
        columnas: [
          {
              key: 'prod1',
              label: 'Producto 1',
              sortable: true,
              tdClass: 'prod1_matriz',
          },
          {
              key: 'prod2',
              label: 'Producto 2',
              sortable: true,
              tdClass: 'prod2_matriz',
          },
          {
              key: 'created_at',
              label: 'Fecha resultado',
              sortable: true,
              tdClass: 'fecha_resultado_matriz',
          },
          {
              key: 'compatibilidad_resultado',
              label: 'Resultado',
              sortable: true,
              tdClass: 'compatibilidad_resultado_matriz',
          },
          {
              key: 'actions',
              label: 'Opciones',
              tdClass: 'actions_matriz'
          },
        ]
      }
    },
    components: {
      GenerarMatriz
    },
    async created() {
      this.validarPermisos();
      this.load(true);
      this.acls = getAcls();
      this.rol = this.acls.roles.toString();
      if (this.listarEmpresas) {
        await this.getEmpresaFiltro();
      } else {
        this.selectedEmpresa.id = this.acls.empresa
        await this.obtenerProductosPagos();
      }
      this.listaEmpresas = this.empresas;
      if (!this.fabricantes.length) {
        await this.listarFabricantes();
      }

      if (!this.estados.length) {
        await this.getEstados();
      }
      this.load(false);
    },
    methods: {   
      validarPermisos() {
        this.listarEmpresas = validarPermisoComponente('listar-empresas-asignadas');
      },
      async setPagePagination(page) {
        let filtro = {'cantidad': page, 'tipo': 'resultadosMatriz'};
        this.load(true);
        await this.setPage(filtro);
        await this.listarResultados();
        this.load(false);
      },
      async setPerPagePagination(perPage) {
        let filtro = {'cantidad': perPage, 'tipo': 'resultadosMatriz'};
        this.load(true);
        this.setPerPage(filtro);
        await this.listarResultados();
        this.load(false);
      },
      async obtenerProductosPagos(event) {
        if (this.rol == "Admin" || this.rol == "SuperAdmin" || this.rol == "AdminTecnico") {
          let empresa = this.listaEmpresas.find((e => e.id === event));
          this.setEmpresa({'nombre': empresa.nombre});
        }
        this.load(true);        
        if (this.tipoMatriz.tipo == 'almacenamiento') {
          await this.listarResultados();
          await this.listarProductosComparados();
        }
        this.load(false);
      },
      async buscarEmpresa(query) {
        if (query.length >= 3) {
              setTimeout(() => {
                this.listaEmpresas = this.empresas.filter(item => {
                    return item.nombre.toLowerCase()
                      .indexOf(query.toLowerCase()) > -1;
              });
            }, 200);
        } else {
            this.listaEmpresas = [];
        }
      },
      ...mapActions('matrizCompatibilidad', [
        'getEmpresaFiltro',
        'listarResultados',
        'listarProductosComparados'
      ]),
      ...mapMutations('dashboard', [
        'load'
      ]),
      ...mapMutations('matrizCompatibilidad', [
        'setModalMatriz',
        'setPerPage',
        'setPage',
        'setEmpresa',
        'setPaso',
        'resetProductos',
        'limpiarEmpresa'
      ]),
      ...mapActions('productos', [
        'listarFabricantes',
        'getEstados'
      ])
    },
    computed: {
        ...mapGetters('matrizCompatibilidad', [
          'getModalMatriz'
        ]),
        ...mapState('matrizCompatibilidad', [
          'total',
          'empresas',
          'selectedEmpresa',
          'modalMatriz',
          'filtroResultados',
          'listadoResultados',
          'tipoMatriz'
        ]),
        ...mapState('productos', [
            'fabricantes',
            'estados'
        ])
    }
}
</script>
<style>
.prod1_matriz {
    width: 250px !important;
    max-width: 250px !important;
    min-width: 250px !important;
}
.prod2_matriz {
    width: 250px !important;
    max-width: 250px !important;
    min-width: 250px !important;
}
.fecha_resultado_matriz {
    width: 150px !important;
    max-width: 150px !important;
    min-width: 150px !important;
}
</style>